import { render, staticRenderFns } from "./AddDecreaseAmount.vue?vue&type=template&id=16da43c2&scoped=true"
import script from "./AddDecreaseAmount.vue?vue&type=script&lang=js"
export * from "./AddDecreaseAmount.vue?vue&type=script&lang=js"
import style0 from "./AddDecreaseAmount.vue?vue&type=style&index=0&id=16da43c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da43c2",
  null
  
)

export default component.exports